import { ArrowLeftRight } from 'lucide-react'

import { SplitsLink } from '~/components/Link'
import { Button } from '~/components/component-library'
import { SupportedChainId } from '~/constants/chains'
import { IAddress } from '~/types'

type SwapDirection = 'buy' | 'sell'

type SwapButtonProps = {
  defaultSender?: IAddress
  defaultToken?: IAddress
  defaultChainId?: SupportedChainId
  direction?: SwapDirection
  isDisabled?: boolean
  disabledReason?: string
} & (
  | { asChild: true; children: React.ReactNode }
  | { asChild?: false; children?: never }
)

export const buildSwapQueryParams = ({
  defaultSender,
  defaultToken,
  defaultChainId,
  direction = 'sell',
}: SwapButtonProps) => {
  const params = new URLSearchParams()

  if (defaultSender) {
    params.set('account', defaultSender)
  }
  if (defaultToken) {
    const tokenParam = direction === 'buy' ? 'buyToken' : 'sellToken'
    params.set(tokenParam, defaultToken)
  }
  if (defaultChainId) {
    params.set('chainId', defaultChainId.toString())
  }

  const queryString = params.toString()
  return queryString ? `?${queryString}` : ''
}

export const SwapButton = (props: SwapButtonProps) => {
  const queryParams = buildSwapQueryParams(props)

  return (
    <SplitsLink path={`/swap${queryParams}`}>
      {props.asChild ? (
        props.children
      ) : (
        <Button
          variant="secondary"
          prefix={<ArrowLeftRight />}
          isDisabled={props.isDisabled}
          disabledReason={props.disabledReason}
        >
          Swap
        </Button>
      )}
    </SplitsLink>
  )
}
